// Loads video url into iframe when clicking a link to open a modal window.
$(document).on('click', '*[data-video-url]', function(event){
  event.preventDefault();
  // data-target is already defined for bootsrap's modal window opener
  // (usually has data-toggle="modal" too)
  var $modal = $($(this).data('target'));
  var iframeSrc = $(this).data('video-url');

  $modal.find('iframe').attr('src', iframeSrc);

  // Clear the iframe src next time the modal is hidden
  $modal.one('hidden.bs.modal', function () {
    $modal.find('iframe').attr('src', 'about:blank');
  });
})
